import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Slide,
  Stack,
  TableCell,
  TableRow,
  styled,
  tableCellClasses,
  Tooltip,
} from "@mui/material";
import {
  Dispatch,
  FC,
  forwardRef,
  SetStateAction,
  useCallback,
  useState,
} from "react";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import AppRegistrationIcon from "@mui/icons-material/AppRegistration";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import dateFormat from "dateformat";
import { AxiosInstance } from "axios";

import { TransitionProps } from "@mui/material/transitions";
import { LoadingButton } from "@mui/lab";
import { PrevisionnelInterface } from "./PrevisionnelQuantiteInterface";
import { btnStyle } from "../../parametrage/user/Tabs/utilisateur/UtilisateurRow";
import {
  AllMounth,
  profilToAccessFromSaisieManager,
} from "../../../../constants/Constants";
import { ConnectedUser } from "../../../../utils/utils";
import OptionalWidthModal from "../../../../commons/optional-width-modal/OptionalWidthModal";
import UpdatePrevisionnelQt from "../../../forms/previsionnelQt/UpdatePrevisionnelQt";
import { AlertType } from "../../../../types/AlertType";

interface PrevisionnelRowProps {
  previsionnel: PrevisionnelInterface;
  http: AxiosInstance;
  reloadList: () => void;
  setOpenSnack: Dispatch<SetStateAction<boolean>>;
  setAlerteMessage: Dispatch<SetStateAction<string>>;
  setAlertType: Dispatch<SetStateAction<AlertType>>;
}

const StyledTableCell = styled(TableCell)(() => ({
  [`&.${tableCellClasses.body}`]: {
    fontSize: 11,
    textAlign: "center",
    color: "#fff",
  },
}));

const Transition = forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const PrevisionnelQtRow: FC<PrevisionnelRowProps> = ({
  previsionnel,
  http,
  reloadList,
  setOpenSnack,
  setAlertType,
  setAlerteMessage,
}) => {
  const [openModalDelete, setOpenModalDelete] = useState<boolean>(false);
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [deleteLoading, setDeleteLoading] = useState<boolean>(false);

  const user = ConnectedUser();
  const bgColorEditBtn = profilToAccessFromSaisieManager.includes(
    user?.profils?.libelle
  )
    ? "#070d23"
    : "#1A168C";

  // Handle
  const handleDelete = useCallback(() => {
    setDeleteLoading(true);
    http.delete(`forecast/delete/${previsionnel?.id}`).then(() => {
      setOpenModalDelete(false);
      setDeleteLoading(false);
      reloadList();
      setAlerteMessage("Suppresion efféctuée !");
      setAlertType("success");
      setOpenSnack(true);
    });
  }, []);

  const handleCloseDeleteModal = () => {
    setOpenModalDelete(false);
  };

  const handleClose = () => {
    setOpenModal(false);
  };

  return (
    <>
      <TableRow>
        <StyledTableCell>{previsionnel?.pays_libelle}</StyledTableCell>
        <StyledTableCell>{previsionnel?.bu_libelle}</StyledTableCell>
        <StyledTableCell>{previsionnel?.client_libelle}</StyledTableCell>
        <StyledTableCell>{previsionnel?.operation_libelle}</StyledTableCell>
        <StyledTableCell>{previsionnel?.code_article_libelle}</StyledTableCell>
        <StyledTableCell>{previsionnel?.article_libelle}</StyledTableCell>
        <StyledTableCell>
          {AllMounth.find((x) => x.id === previsionnel?.mois)?.mounth}
        </StyledTableCell>
        <StyledTableCell>{previsionnel?.annee}</StyledTableCell>
        <StyledTableCell>{previsionnel?.heure_prev}</StyledTableCell>
        <StyledTableCell>{previsionnel?.acte_prev}</StyledTableCell>
        <StyledTableCell>
          <Stack
            direction="row"
            spacing={1}
            display="flex"
            justifyContent="center"
          >
            <Tooltip title="Encours de dev">
              <Button
                size="small"
                variant="outlined"
                sx={btnStyle({
                  bgColor: bgColorEditBtn,
                  hoverColor: "Gray",
                  color: "#fff",
                })}
                startIcon={<AppRegistrationIcon />}
                // disabled
                onClick={() => setOpenModal(true)}
              >
                Modifier
              </Button>
            </Tooltip>
            <Button
              size="small"
              variant="outlined"
              sx={btnStyle({
                bgColor: "#FF0000",
                hoverColor: "#FE3737",
              })}
              disabled={
                !profilToAccessFromSaisieManager.includes(
                  user?.profils?.libelle
                )
              }
              startIcon={<DeleteForeverIcon />}
              onClick={() => setOpenModalDelete(true)}
            >
              Supprimer
            </Button>
          </Stack>
        </StyledTableCell>
      </TableRow>
      <Dialog
        open={openModalDelete}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleCloseDeleteModal}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>{"Confirmation"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            Vous êtes sur le point de supprimer l'heure agent, êtes-vous sûr de
            vouloir poursuivre cette action ?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <LoadingButton
            onClick={() => handleDelete()}
            startIcon={<DeleteForeverIcon />}
            loading={deleteLoading}
            loadingPosition="end"
            sx={btnStyle({
              bgColor: "#FF0000",
              hoverColor: "#FE3737",
            })}
            variant="contained"
          >
            Oui
          </LoadingButton>
          <LoadingButton
            onClick={() => handleCloseDeleteModal()}
            startIcon={<ExitToAppIcon />}
            sx={{ textTransform: "none" }}
            loadingPosition="end"
            variant="contained"
            color="inherit"
          >
            Non
          </LoadingButton>
        </DialogActions>
      </Dialog>
      <OptionalWidthModal
        title="Modifier Previsionnel Quantite"
        onClose={handleClose}
        open={openModal}
        breackPoint="md"
      >
        <UpdatePrevisionnelQt
          http={http}
          onClose={handleClose}
          previsionnel={previsionnel}
          reloadList={reloadList}
          setAlerteMessage={setAlerteMessage}
          setAlertType={setAlertType}
          setOpenSnack={setOpenSnack}
        />
      </OptionalWidthModal>
    </>
  );
};

export default PrevisionnelQtRow;
